import { PropertyFieldType } from '../../../../../BotProperties/components/Properties/types'
import { UserProfileProperty } from '../../../../../BotUsers/components/Users/types'

const PropertyValueValidator: (type: PropertyFieldType, value: UserProfileProperty['value'] | null) => boolean = (type, value) => {
  if (value) {
    if (type === PropertyFieldType.Flag) {
      return typeof value === 'boolean'
    } else if (type === PropertyFieldType.Phone) {
      return /^\+?[\d)(-]+$/.test(String(value))
    } else if (type === PropertyFieldType.Email) {
      return /^(.+)@(\S+)$/.test(String(value))
    } else if (type === PropertyFieldType.Number || type === PropertyFieldType.Double) {
      return typeof value === 'number'
    } else if (type === PropertyFieldType.Files && Array.isArray(value)) {
      return value.length > 0
    } else {
      return typeof value === 'string' && value.trim().length > 0
    }
  }

  return false
}

export default PropertyValueValidator
